import * as Data from "../../Data";

export interface IInitialDates {
    DateFrom: Data.CData;
    DateTo: Data.CData;
}

export const GetInitialDates = (): IInitialDates => {
    const today = new Date();
    const DateFrom: Data.CData = new Data.CData();
    const DateTo: Data.CData = new Data.CData();

    DateFrom.Giorno = 1;
    DateFrom.Mese = today.getMonth() + 1;
    DateFrom.AddMesi(-3);

    DateTo.Mese = today.getMonth() + 1;
    DateTo.Giorno = today.getDate();
    return {
        DateFrom,
        DateTo
    };
};



// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardHelpers.ts